export default {"src":"/_next/static/media/online.6965fcab.svg","height":100,"width":101};